import { StyleSheet, View, Text, type TextInput } from 'react-native'
import { Input } from '@/src/common/components/Input/Input'
import { clearNonNumericValues } from '@/src/common/utils/input'
import { UnitedStatesIcon } from '@/src/assets/icons/flags/UnitedStatesIcon'
import { forwardRef, type ComponentProps } from 'react'

export interface InputPhoneValueType {
  countryCode: string
  phoneNumber: string
}
export interface InputPhoneInterface extends ComponentProps<typeof Input> {
  inputValue?: InputPhoneValueType
  onChangeValue?: (value: InputPhoneValueType) => void
  picker?: boolean
}

export const InputPhone = forwardRef<TextInput, InputPhoneInterface>(
  ({ onChangeValue, inputValue, picker = true, ...inputProps }, ref) => (
    <Input
      ref={ref}
      autoComplete="tel"
      segmentAction="User Inputs Phone"
      keyboardType={inputProps.keyboardType ?? 'number-pad'}
      {...(picker
        ? {
            leftIcon: (
              <View style={{ flexDirection: 'row' }}>
                <UnitedStatesIcon />
                <Text style={styles.textView}>{inputValue?.countryCode}</Text>
              </View>
            ),
          }
        : undefined)}
      value={inputProps.value ?? inputValue?.phoneNumber ?? ''}
      {...inputProps}
      onChangeText={
        inputProps.onChangeText ??
        ((phoneNumberValue) => {
          if (onChangeValue !== undefined) {
            const filteredNumericValue = clearNonNumericValues(phoneNumberValue)
            onChangeValue({
              countryCode: inputValue?.countryCode ?? '',
              phoneNumber: filteredNumericValue,
            })
          }
        })
      }
    />
  ),
)

const styles = StyleSheet.create({
  textView: {
    paddingLeft: 10,
    paddingRight: 3,
  },
  chevronView: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
})

export default InputPhone
